




import { Mixins, Component } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../base/components/system";
import { IFormatObjectTemporaryImage } from "../../../../../domain/editableFormat";
import { FormatStructureEditableMixin } from "../../mixins";

@Component
export default class StoreEditor extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  setTemporaryImages(value: IFormatObjectTemporaryImage[]) {
    this.writePropertyWhenValid(s => s.setTemporaryImages(value));
  }

  setSelectedTemporaryImage(value: IFormatObjectTemporaryImage) {
    this.writePropertyWhenValid(s => s.setSelectedTemporaryImage(value));
  }
}
